import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  OnChanges,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PoEmailService } from "../../../../core/services/po-email.service";
import { ActivatedRoute } from "@angular/router";
import { OrderNotesSidebarService } from "../../../../core/services/order-notes-sidebar.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import { lastValueFrom, pluck } from "rxjs";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { v4 as uuidv4 } from "uuid";
import { Title } from "@angular/platform-browser";
import { EmailTemplates } from "../../../../core/models/orders/emailTemplates";
import { GetPurchaseOrderConfirmationJournalRequest } from "../../../../core/models/orders/getPurchaseOrderConfirmationJournalRequest";
import { POEmailContact } from "../../../../core/models/orders/poEmailContact";
import { PoEmailData } from "../../../../core/models/orders/PoEmailData";
import { POEmailLogs } from "../../../../core/models/orders/poEmailLogs";
import { SalesOrderBCInformationDto } from "../../../../core/models/orders/salesOrderBCInformation";
import { SalesOrderNotes } from "../../../../core/models/orders/salesOrderNotes";
import { VendorInformationForPOEmailDto } from "../../../../core/models/orders/vendorInformationForPOEmailDto";
import { Contact } from "../../../../core/models/shared/contact";
import { FileUploadDto } from "../../../../core/models/shared/fileUploadDto";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { LoaderService } from "../../../../core/services/loader.service";
import { EnumOrderEmailState } from "../../../../shared/enums/orderEmailState.enum";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { PoEmailContactsComponent } from "../po-email-contacts/po-email-contacts.component";
import { PoEmailAttachmentsComponent } from "../po-email-attachments/po-email-attachments.component";
import { PoEmailRecipientsComponent } from "../po-email-recipients/po-email-recipients.component";
import { PoEmailHeaderComponent } from "../po-email-header/po-email-header.component";
import { DisplayPdfFrameComponent } from "../display-pdf-frame/display-pdf-frame.component";
import { EditorComponent } from "../../../../shared/components/editor/editor.component";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { OrderBcEmailDto } from "../../../../core/models/orders/orderBcEmailDto";
import { CommonModule } from "@angular/common";
import { GetUserProjectDto } from "../../../../core/models/samplePO/details/getUserProjectDto";

//declare let tinymce: any;

@Component({
  selector: "jni-po-email",
  templateUrl: "./po-email.component.html",
  styleUrls: ["./po-email.component.scss"],
  imports: [
    PoEmailContactsComponent,
    PoEmailAttachmentsComponent,
    PoEmailRecipientsComponent,
    PoEmailHeaderComponent,
    DisplayPdfFrameComponent,
    EditorComponent,
    CommonModule,
  ],
})
@UntilDestroy()
export class PoEmailComponent implements OnInit, OnDestroy, OnChanges {
  poEmailForm!: FormGroup;
  poTemplates: EmailTemplates[] = [];
  purchaseOrderNumberList: string[] = [];
  vendorContacts: Contact[] = [];
  contacts: Contact[] = [];
  recipientsList: POEmailContact[] = [];
  loginUserInformation = {} as SalesOrderBCInformationDto;
  vendorInformation = {} as VendorInformationForPOEmailDto;
  saleOrderId = "";
  poNumber = "";
  poJournalPdf = "";
  allBC: GetUserProjectDto[] = [];
  isBC = false;
  filesObject: FileUploadDto[] = [];
  totalFileSizeInKb = 0;
  bcPersonnelNumber = "";
  bacPersonnelNumber = "";
  userPersonnelNumber = "";
  userData!: GetUserDto;
  bcEmail = "";
  bacEmail = "";
  fileAttachmentUrlArray = new Map<string, string>();
  currentTemplete!: EmailTemplates;
  watermark = "";
  primaryVendorContactEmail = "";
  poJournalPdfStatus = false;
  poEmailDisplayModal = false;
  emailButtonStatus = false;
  poEmailScreenStatus = false;
  emailToArray: string[] = [];
  csvEmailTo = "";
  poJournalPdfUrl = "";
  poNumberParams = "";
  displayRushRevisedSection = true;
  windowState = 0;
  oldTitle = "";
  customerIdD365 = "";
  clientLists: ClientSearchList[] = [];
  templateType = "";
  fileName = "";
  @ViewChild("emailComponent", { static: false })
  emailComponent!: EditorComponent;
  @Input() poEmailData: PoEmailData = {} as PoEmailData;
  displaySendButton = true;
  @Input() isAnyUnCommitLines = false;
  @Output() refreshOrderLinesGrid = new EventEmitter();
  @Output() closePOEmailModalEvent = new EventEmitter();
  formErrors: Record<string, string> = {
    subject: "",
  };
  @Input() isModal = false;

  validationMessages: Record<string, Record<string, string>> = {
    subject: {
      maxlength: "Subject must be less than 255 characters.",
    },
  };
  templateBody = "";

  constructor(
    private _fb: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _poEmailService: PoEmailService,
    private _orderNotesSidebarService: OrderNotesSidebarService,
    private _saleOrderService: SaleOrderService,
    private _msalApisService: MsalApiService,
    private _orderSummaryService: OrderSummaryService,
    private _samplepoListingService: SamplepoListingService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private titleService: Title
  ) {
    this.oldTitle = this.titleService.getTitle();
    this._activatedRoute.params.subscribe(params => {
      this.saleOrderId = params["id"];
      this.poNumberParams = params["poNumber"];
      this.windowState = params["windowState"];
    });
    this.initializeForm();
    this.setTitle(this.poNumberParams);

    // this.setSender();
  }
  ngOnDestroy(): void {
    this.titleService.setTitle(this.oldTitle);
  }

  ngOnInit(): void {
    this.getSaleOrderHeaderData(false);
    this.getPOTemplates();
    this.getAllLinePoNumber();
    //this.getSalesOrderBCInformation();
    this.getUserProfile();
    // this.setSender();

    if (
      this.windowState == EnumOrderEmailState.ProjectConfirmation ||
      this.windowState == EnumOrderEmailState.PrintOrderSummary ||
      this.windowState == EnumOrderEmailState.PrintProjectApproval
    ) {
      this.displayRushRevisedSection = false;
      this.setTitle("");
    } else if (this.windowState == EnumOrderEmailState.PoPrinting) {
      this.setTitle(this.poNumberParams);
    }
    this.setPdfFileName();
  }

  ngOnChanges() {
    if (this.saleOrderId) {
      //this.ngOnInit();
    }

    if (this.poEmailData?.windowState) {
      this.saleOrderId = this.poEmailData.saleOrderId;
      this.poNumberParams = this.poEmailData.poNumber;
      this.windowState = this.poEmailData.windowState;
    }
    this.setPdfFileName();
  }

  logValidationErrors(group: FormGroup = this.poEmailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  private initializeForm() {
    //const userJson = localStorage.getItem('user') || '';
    //const userObject = JSON.parse(userJson);
    //const useremail = userObject?.account?.username || '';
    this.poEmailForm = this._fb.group({
      header: this._fb.group({
        templateId: [null],
        poNumber: [""],
        poNumberRevision: [{ value: "", disabled: true }],
        rush: [false],
        revised: [false],
        sender: [{ value: "", disabled: true }],
        subject: ["", [Validators.maxLength(255)]],
        additionalSubject: [""],
        reply: [{ value: "", disabled: true }],
        saleOrderId: [""],
      }),
    });
  }

  getPOTemplates() {
    this._loaderService.setLoaderState(true);
    if (
      this.windowState == EnumOrderEmailState.ProjectConfirmation ||
      this.windowState == EnumOrderEmailState.PrintOrderSummary ||
      this.windowState == EnumOrderEmailState.PrintProjectApproval
    ) {
      this.templateType = "Order-Project-Confirmation-Email";
    } else if (this.windowState == EnumOrderEmailState.PoPrinting) {
      this.templateType = "PO-Email";
    } else {
      this.templateType = "PO-Email";
    }

    this._poEmailService
      .getEmailTemplatesByType(this.templateType)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.poTemplates = res.data || [];
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getSaleOrderHeaderData(getloaderStatus: boolean) {
    if (this.saleOrderId) {
      this._loaderService.setLoaderState(getloaderStatus);
      this.getOrderBacEmailBySalesOrderId(this.saleOrderId);
      this._orderSummaryService
        .getSaleOrderHeaderData(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              if (
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.brandingConsultantD365
              ) {
                this.bcPersonnelNumber =
                  res.data.salesOrderHeader?.salesOrderHeader?.brandingConsultantD365;
                this.getBrandingConsultantOnSaleOrder(this.userData);
              }
              if (
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.accountsCoordinatorD365
              ) {
                this.bacPersonnelNumber =
                  res.data.salesOrderHeader?.salesOrderHeader?.accountsCoordinatorD365;
              }
              if (res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365) {
                this.customerIdD365 =
                  res.data.salesOrderHeader.salesOrderHeader.customerIdD365;
                if (
                  this.windowState == EnumOrderEmailState.ProjectConfirmation ||
                  this.windowState == EnumOrderEmailState.PrintOrderSummary ||
                  this.windowState == EnumOrderEmailState.PrintProjectApproval
                ) {
                  this.getClientAndProspectByNameAndAccountNumberFilter();
                }
              }
            } else {
              this._toastr.error("Error", res.message || "Data not found");
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Data not found");
          },
        });
    }
  }
  getOrderBacEmailBySalesOrderId(saleOrderId: string) {
    if (this.saleOrderId) {
      this._orderSummaryService
        .getOrderBacEmailBySalesOrderId(saleOrderId)
        .pipe()
        .subscribe((res: GenericResponseDto<OrderBcEmailDto>) => {
          if (res?.status === "Success" && res?.data?.email) {
            const findIfEmailAlreadyExists = this.recipientsList.findIndex(
              x => x.locatorD365?.toLowerCase() === res?.data?.email?.toLowerCase()
            );
            if (findIfEmailAlreadyExists === -1) {
              this.patchValueInRecipients(res?.data?.email);
            }
          }
        });
    }
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          this.userPersonnelNumber = res?.data?.personnelNumber;
          this.getBrandingConsultantOnSaleOrder(res?.data);
        }
      },
    });
  }

  getBrandingConsultantOnSaleOrder(data: GetUserDto) {
    if (data && this.bcPersonnelNumber) {
      if (
        data?.userRoleId === UserRole.Admin ||
        data?.personnelNumber === this.bcPersonnelNumber
      ) {
        this.bcEmail = data?.sendEmailAs;
        this.bacEmail = data?.primaryBACEmail;
        this.isBC = true;
        this.poEmailForm.patchValue({
          header: {
            sender: this.bcEmail || "",
            reply: this.bcEmail || "",
          },
        });
        //this.patchValueInRecipients(this.bacEmail);
        this.loginUserInformation.email = this.bcEmail;
        this.loginUserInformation.personnelNumber = data.personnelNumber;
        this.loginUserInformation.projectId = data.projectId ?? "";
        this.loginUserInformation.projectName = data.name ?? "";
        this.patchValueInEditor();
      } else {
        this.bacEmail = data?.sendEmailAs;
        this.isBC = false;
        this.poEmailForm.patchValue({
          header: {
            sender: this.bacEmail || "",
            reply: this.bacEmail || "",
          },
        });
        //this.bcEmail = data?.loginEmail;
        //this.patchValueInRecipients(this.bcEmail);
        this.getSalesOrderBCInformation();
        this.loginUserInformation.email = this.bacEmail;
        this.loginUserInformation.projectName = data.name || "";
        this.patchValueInEditor();
      }
    }
  }

  patchValueInRecipients(email: string) {
    const object: POEmailContact = {
      id: Date.now(),
      locatorD365: email,
      descriptionD365: "",
      purposeD365: "",
      isPrimaryD365: "",
      addType: "CC",
      otherSpecification: "",
      createdDate: "",
      createdBy: "",
      lastModifiedDate: null,
      lastModifiedBy: null,
      isActive: false,
    };
    this.recipientsList.push(object);
  }

  templatedSelected(id: number) {
    if (id > 0) {
      const index = this.poTemplates.findIndex(x => x.id == id);
      if (index > -1) {
        const template = this.poTemplates[index];
        this.currentTemplete = template;
        this.templateBody = template.body;
        //this.emailComponent.emailEditor.editor.setContent(template.body);
        if (this.vendorInformation.name) {
          this.patchValueInEditor();
        }
      }
    }
  }

  setTitle(poNumber: string) {
    //Set titles as per the window state
    if (this.windowState == EnumOrderEmailState.ProjectConfirmation) {
      this.titleService.setTitle(`Conf-${this.saleOrderId}`);
    } else if (this.windowState == EnumOrderEmailState.PrintOrderSummary) {
      this.titleService.setTitle(`Summary-${this.saleOrderId}`);
    } else if (this.windowState == EnumOrderEmailState.PrintProjectApproval) {
      this.titleService.setTitle(`Approval-${this.saleOrderId}`);
    } else if (this.windowState == EnumOrderEmailState.PoPrinting) {
      if (poNumber) {
        this._saleOrderService
          .getVendorInformationForPOEmail(poNumber)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this.titleService.setTitle(
                `${poNumber} - ${res?.data?.name || ""}`
              );
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      }
    } else {
      if (poNumber) {
        this._saleOrderService
          .getVendorInformationForPOEmail(poNumber)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              if (
                this.windowState != EnumOrderEmailState.ProjectConfirmation &&
                this.windowState != EnumOrderEmailState.PrintProjectApproval &&
                this.windowState != EnumOrderEmailState.PrintOrderSummary &&
                this.windowState != EnumOrderEmailState.PoPrinting
              ) {
                this.titleService.setTitle(
                  `${poNumber} - ${res?.data?.name || ""}`
                );
              }
            },

            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      }
    }
  }

  getAllBC() {
    this._samplepoListingService.getAllBrandingConsultant().subscribe({
      next: res => {
        if (res.status.toLowerCase() == "success") {
          this.allBC = res.data;
          const index = this.allBC.findIndex(
            x => x.personnelNumber == this.loginUserInformation.personnelNumber
          );
          if (index > -1) {
            this.isBC = true;
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  setSender() {
    //const userJson = localStorage.getItem('user') ?? '';
    //const userObject = JSON.parse(userJson);
    //const useremail = userObject?.account?.username || '';
    this.poEmailForm.patchValue({
      header: {
        sender: this.bcEmail,
      },
    });
  }

  getAllLinePoNumber() {
    if (this.saleOrderId) {
      this._loaderService.setLoaderState(true);
      this._orderNotesSidebarService
        .getAllLinePoNumber(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            this.purchaseOrderNumberList = res.data;
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  getSalesOrderBCInformation() {
    this._poEmailService
      .getSalesOrderBCInformation(this.saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.bcEmail = res.data.email;
            const findIfEmailAlreadyExists = this.recipientsList.findIndex(
              x => x.locatorD365?.toLowerCase() === res.data.email.toLowerCase()
            );
            if (findIfEmailAlreadyExists === -1) {
              this.patchValueInRecipients(this.bcEmail);
            }
          }
          //this.loginUserInformation = res.data;
          // this.patchValueInEditor();
          //if (res.status.toLowerCase() == 'success') {
          // this.getAllBC();
          // this.poEmailForm.patchValue({
          //   header: {
          //     sender: res.data.email || ''
          //   }
          // });
          //}
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getVendorInformationForPOEmail(poNumber: string) {
    this.emailButtonStatus = false;
    //this._loaderService.setLoaderState(true);
    this.poNumber = poNumber;
    if (this.poNumber) {
      if (this.poEmailForm.get(["header", "rush"])?.value) {
        this._orderSummaryService
          .printPOForSalesOrder(poNumber, "Rush")
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.poJournalPdf = res.data;

                if (this.poJournalPdf) {
                  this.emailButtonStatus = true;
                }
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      } else if (this.poEmailForm.get(["header", "revised"])?.value) {
        this._orderSummaryService
          .printPOForSalesOrder(poNumber, "Revised")
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.poJournalPdf = res.data;

                if (this.poJournalPdf) {
                  this.emailButtonStatus = true;
                }
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      } else {
        this._orderSummaryService.printPOForSalesOrder(poNumber).subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.poJournalPdf = res.data;

              if (this.poJournalPdf) {
                this.emailButtonStatus = true;
              }
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
      }

      if (poNumber) {
        this._saleOrderService
          .getVendorInformationForPOEmail(poNumber)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this.vendorInformation = res.data;
              this.patchValueInEditor();
              if (res.status.toLowerCase() == "success") {
                this.getAllContactsByAccountNumber(
                  this.vendorInformation.vendorAccountNumber,
                  this.vendorInformation.partyNumber
                );
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      }

      const poNumberObject: GetPurchaseOrderConfirmationJournalRequest = {
        purchaseOrderID: poNumber,
      };
      this._poEmailService
        .GetPurchaseOrderConfirmationJournal(poNumberObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.poEmailForm.patchValue({
                header: { poNumberRevision: res?.data?.PurchaseJournal ?? "" },
              });
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  getAllContactsByAccountNumber(accountNumber: string, partyNumber = "") {
    this._saleOrderService
      .getAllContactsByAccountNumber(accountNumber, partyNumber)
      .pipe(pluck("data"))
      .subscribe({
        next: data => {
          this.contacts = data.filter(
            x => x.typeD365?.toLowerCase() == "email"
          );
          this.vendorContacts = JSON.parse(JSON.stringify(this.contacts));
          const primaryContact = this.contacts.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" &&
              x.purposeD365?.toLowerCase()?.includes("business")
          );
          if (primaryContact.length > 0) {
            const object: POEmailContact = {
              locatorD365: primaryContact[0].locatorD365,
              descriptionD365: primaryContact[0].descriptionD365,
              purposeD365: primaryContact[0].purposeD365,
              isPrimaryD365: primaryContact[0].isPrimaryD365,
              addType: "TO",
              otherSpecification: "",
              createdDate: "",
              createdBy: "",
              lastModifiedDate: null,
              lastModifiedBy: null,
              isActive: false,
            };
            this.primaryVendorContactEmail =
              primaryContact[0].locatorD365 ?? "";
            this.recipientsList.push(object);
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  addCC(addCCList: Contact[]) {
    addCCList.forEach(x => {
      // if (!this.isValidEmail(x.locatorD365)) {
      //   this._toastr.error('Invalid Email', 'Error');
      //   return;
      // }
      const index = this.vendorContacts.findIndex(a => a.id == x.id);
      if (index > -1) {
        this.vendorContacts.splice(index, 1);
      }
      this.recipientsList.push({
        ...x,
        addType: "CC",
        descriptionD365: x.descriptionD365 ?? "",
      });
    });
  }

  addTO(addTOList: Contact[]) {
    addTOList.forEach(x => {
      // if (!this.isValidEmail(x.locatorD365)) {
      //   this._toastr.error('Invalid Email', 'Error');
      //   return;
      // }
      const index = this.vendorContacts.findIndex(a => a.id == x.id);
      if (index > -1) {
        this.vendorContacts.splice(index, 1);
      }
      this.recipientsList.push({
        ...x,
        addType: "TO",
        descriptionD365: x.descriptionD365 ?? "",
      });
    });
  }

  recipientsDeleted(deletedList: POEmailContact[]) {
    for (const contact of deletedList) {
      const index = this.recipientsList.findIndex(x => x.id == contact.id);
      if (index > -1) {
        this.recipientsList.splice(index, 1);
      }
      if (this.contacts.findIndex(x => x.id == contact.id) > -1) {
        this.vendorContacts.push(contact);
      }
    }
  }

  recipientsAdd() {
    //const userJson = localStorage.getItem('user') || '';
    //const userObject = JSON.parse(userJson);
    //const useremail = userObject?.account?.username || '';
    this.recipientsList.push({
      id: Date.now(),
      addType: "CC",
      locatorD365: "",
      firstNameD365: "",
      lastNameD365: "",
      typeD365: "",
      createdDate: new Date().toISOString(),
      createdBy: this.bcEmail,
      lastModifiedDate: new Date().toISOString(),
      lastModifiedBy: this.bcEmail,
      isActive: true,
      descriptionD365: undefined,
      otherSpecification: "",
    });
  }

  patchValueInEditor() {
    let content = this.templateBody; //this.emailComponent?.emailEditor?.editor?.getContent();
    if (content) {
      if (
        this.windowState == EnumOrderEmailState.ProjectConfirmation ||
        this.windowState == EnumOrderEmailState.PrintOrderSummary ||
        this.windowState == EnumOrderEmailState.PrintProjectApproval
      ) {
        content = content.replace(
          "#{ClientName}",
          this.vendorInformation?.name
        );
        content = content.replace("{SalesOrder}", this.saleOrderId);
        content = content.replace(
          "#{currentUser}",
          this.userData?.displayEmailAs || ""
        );
        content = content.replace("#{BCName}", this.userData?.name ?? "");
        this.templateBody = content;
        //this.emailComponent.emailEditor.editor.setContent(content);
      } else if (this.windowState == EnumOrderEmailState.PoPrinting) {
        content = content.replace(
          "#{VendorLegalName}",
          this.vendorInformation.name
        );
        content = content.replace("#{PONumber}", this.poNumber);
        //const userJson = localStorage.getItem('user') ?? '';
        //const userObject = JSON.parse(userJson);
        //const useremail = userObject?.account?.username || '';
        content = content.replace(
          "#{currentUser}",
          this.loginUserInformation.email ?? ""
        );
        content = content.replace(
          "#{BCName}",
          this.loginUserInformation.projectName ?? ""
        );
        this.templateBody = content;
        //this.emailComponent.emailEditor.editor.setContent(content);
      } else {
        content = content.replace(
          "#{VendorLegalName}",
          this.vendorInformation.name
        );
        content = content.replace("#{PONumber}", this.poNumber);
        //const userJson = localStorage.getItem('user') ?? '';
        //const userObject = JSON.parse(userJson);
        //const useremail = userObject?.account?.username || '';
        content = content.replace(
          "#{currentUser}",
          this.loginUserInformation.email ?? ""
        );
        content = content.replace(
          "#{BCName}",
          this.loginUserInformation.projectName ?? ""
        );
        this.templateBody = content;
        //this.emailComponent.emailEditor.editor.setContent(content);
      }
    }
  }

  getAttachmentFileArray(event: FileUploadDto[]) {
    this.filesObject = event;
  }

  getTotalFileSize(event: number) {
    this.totalFileSizeInKb = event;
  }

  submitButtonlogValidationErrors(group: FormGroup = this.poEmailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  attachmentFileUrlArray(fileUrl: Map<string, string>) {
    this.fileAttachmentUrlArray = fileUrl;
  }

  getBase64ForOrder(base64: string) {
    this.poJournalPdf = base64;
  }

  async sendEmail(content: string) {
    this.submitButtonlogValidationErrors();
    this.csvEmailTo = "";
    if (!this.poEmailForm.valid) {
      return;
    }

    if (this.filesObject.length >= 250) {
      this._toastr.error(`File attachments must be less than 250`, "Error");
      return;
    }

    if (this.totalFileSizeInKb >= 33000) {
      this._toastr.error(
        `Total file attachments size must be less than 33MB`,
        "Error"
      );
      return;
    }

    const attachmentObject = {
      base64: this.poJournalPdf,
      fileExtension: ".pdf",
      fileId: 1,
      fileMimeType: "application/pdf",
      fileName: `${this.poNumber}.pdf`,
    } as FileUploadDto;
    const res = await lastValueFrom(
      this._poEmailService.getPoEmailAttachmentUrl(attachmentObject)
    );
    this.poJournalPdfUrl = res.data;

    const toRecipients: MicrosoftGraph.Recipient[] = [];
    const ccRecipients: MicrosoftGraph.Recipient[] = [];
    const to = this.recipientsList.filter(x => x.addType == "TO");
    const cc = this.recipientsList.filter(x => x.addType == "CC");

    for (const x of to) {
      if (!this.isValidEmail(x.locatorD365 ?? "")) {
        this._toastr.error(`Invalid Email ${x.locatorD365}`, "Error");
        return;
      }
    }
    for (const x of cc) {
      if (!this.isValidEmail(x.locatorD365 ?? "")) {
        this._toastr.error(`Invalid Email ${x.locatorD365}`, "Error");
        return;
      }
    }

    to.forEach(x => {
      toRecipients.push({
        emailAddress: {
          address: x.locatorD365,
          name: x.descriptionD365 ?? undefined,
        },
      });
    });
    cc.forEach(x => {
      ccRecipients.push({
        emailAddress: {
          address: x.locatorD365,
          name: x.descriptionD365 ?? undefined,
        },
      });
    });

    this.setPdfFileName();

    const attachement = [];
    attachement.push({
      contentBytes: this.poJournalPdf,
      name: this.fileName,
      contentType: "application/pdf",
      "@odata.type": "#microsoft.graph.fileAttachment",
      size: this.getFileSizeFromBase64(this.poJournalPdf),
    });

    if (this.filesObject.length > 0) {
      for (const key in this.filesObject) {
        attachement.push({
          contentBytes: this.filesObject[key].base64,
          name: `${this.filesObject[key].fileName}`,
          contentType: this.filesObject[key].fileMimeType,
          "@odata.type": "#microsoft.graph.fileAttachment",
          size: this.getFileSizeFromBase64(this.filesObject[key].base64),
        });
      }
    }

    let mailMessage: MicrosoftGraph.Message = {};
    if (this.isBC) {
      const replyTo: MicrosoftGraph.Recipient[] = [
        {
          emailAddress: {
            address: this.loginUserInformation.email,
            name: this.loginUserInformation.projectName,
          },
        },
      ];

      mailMessage = {
        subject: this.poEmailForm.get(["header", "subject"])?.value || "",
        body: {
          contentType: "html",
          content: content,
        },
        toRecipients: toRecipients,
        ccRecipients: ccRecipients,
        replyTo: replyTo,
        attachments: attachement,
      };
    } else {
      const replyTo: MicrosoftGraph.Recipient[] = [
        {
          emailAddress: {
            address: this.loginUserInformation.email,
            name: this.loginUserInformation.projectName,
          },
        },
      ];
      mailMessage = {
        subject: this.poEmailForm.get(["header", "subject"])?.value || "",
        body: {
          contentType: "html",
          content: content,
        },
        toRecipients: toRecipients,
        ccRecipients: ccRecipients,
        attachments: attachement,
        replyTo: replyTo,
      };
    }

    const mail = {
      message: mailMessage,
    };

    this._loaderService.setLoaderState(true);
    this.displaySendButton = false;
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.success("Email Sent Successfully", "Success");
        this.sendEmailsLog(content, ccRecipients, toRecipients);
        const emails = [...toRecipients, ...ccRecipients];
        this.orderNotes(emails);
      },
      error: (err: { error: { error: { message: string } } }) => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          err?.error?.error?.message || "Unable To Send Mail",
          "Error"
        );
        this.displaySendButton = true;
      },
    });
  }

  sendEmailsLog(
    content: string,
    cc: MicrosoftGraph.Recipient[],
    to: MicrosoftGraph.Recipient[]
  ) {
    const attachementsArray = Array.from(this.fileAttachmentUrlArray).map(
      ([key, value]) => ({
        key,
        value,
      })
    );

    if (this.poJournalPdfUrl) {
      attachementsArray.push({
        key: `${this.poNumber}.pdf`,
        value: this.poJournalPdfUrl,
      });
    }

    const rush = this.poEmailForm.get(["header", "rush"])?.value;
    const revised = this.poEmailForm.get(["header", "revised"])?.value;
    if (rush && revised) {
      this.watermark = "All";
    } else if (rush) {
      this.watermark = "Rush";
    } else if (revised) {
      this.watermark = "Revised";
    } else {
      this.watermark = "";
    }

    const poEmailLogs = {
      templateId: this.currentTemplete?.id,
      additionalSubject: this.poEmailForm.get(["header", "additionalSubject"])
        ?.value,
      templateName: this.currentTemplete?.name,
      poNumber: this.poEmailForm.get(["header", "poNumber"])?.value,
      sender: this.poEmailForm.get(["header", "sender"])?.value,
      reply: this.poEmailForm.get(["header", "reply"])?.value,
      subject: this.poEmailForm.get(["header", "subject"])?.value,
      poRevisedVersion:
        this.poEmailForm.get(["header", "poNumberRevision"])?.value || "",
      attachement: JSON.stringify(attachementsArray),
      body: content,
      cc: JSON.stringify(cc),
      to: JSON.stringify(to),
      from: this.poEmailForm.get(["header", "sender"])?.value,
      id: 0,
      watermark: this.watermark,
    } as POEmailLogs;

    this._poEmailService.createPOEmailLogs(poEmailLogs).subscribe();
  }

  orderNotes(to: MicrosoftGraph.Recipient[]) {
    this.emailToArray = [];
    if (to.length > 0) {
      for (const x of to) {
        if (x.emailAddress?.address) {
          this.emailToArray.push(x.emailAddress.address);
        }
      }
      if (this.emailToArray.length > 0) {
        this.csvEmailTo = this.emailToArray.toString();
      }
    }

    const rush = this.poEmailForm.get(["header", "rush"])?.value;
    const revised = this.poEmailForm.get(["header", "revised"])?.value;
    if (rush && revised) {
      this.watermark = "Rush Revised";
    } else if (rush) {
      this.watermark = "Rush";
    } else if (revised) {
      this.watermark = "Revised";
    } else {
      this.watermark = "";
    }

    const saleOrderFormObject = {
      type: "Order notes",
      purchaseOrderId:
        this.poEmailForm.get(["header", "poNumber"])?.value || "",
      description:
        this.watermark !== ""
          ? `${this.watermark} ${this.csvEmailTo}`
          : this.csvEmailTo,
      note: this.primaryVendorContactEmail
        ? `To ${this.primaryVendorContactEmail}`
        : "",
      id: 0,
      purchaseOrderStatus: true,
    } as SalesOrderNotes;

    if (this.saleOrderId) {
      saleOrderFormObject.salesOrderId = this.saleOrderId;
      saleOrderFormObject.portalKey = uuidv4();
    }

    this._orderNotesSidebarService
      .AddSalesOrderNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  isValidEmail(email: string): boolean {
    const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
    if (RegExp(regex).exec(email)) {
      return true;
    }
    return false;
  }

  sendEmailEvent() {
    if (this.poJournalPdf) {
      this.poEmailDisplayModal = true;
    }
  }

  closeModal() {
    this.poEmailDisplayModal = false;
  }

  fetchWatermarkedPdf(watermark: { rush: boolean; revised: boolean }) {
    if (watermark.revised && watermark.rush) {
      this._loaderService.setLoaderState(false);
    } else if (watermark.rush) {
      this._loaderService.setLoaderState(true);
      this._orderSummaryService
        .printPOForSalesOrder(this.poNumber, "Rush")
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.poJournalPdf = res.data;
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    } else if (watermark.revised) {
      this._loaderService.setLoaderState(true);
      this._orderSummaryService
        .printPOForSalesOrder(this.poNumber, "Revised")
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.poJournalPdf = res.data;
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  emailSelection() {
    this.poEmailScreenStatus = true;
  }

  getClientAndProspectByNameAndAccountNumberFilter() {
    this._loaderService.setLoaderState(true);
    this._samplepoListingService
      .getClientAndProspectByNameAndAccountNumberFilter(this.customerIdD365)
      .subscribe({
        next: (res: GenericResponseDto<ClientSearchList[]>) => {
          if (res.data != null) {
            this._loaderService.setLoaderState(false);
            this.clientLists = res.data as unknown as ClientSearchList[];

            if (this.clientLists[0]?.partyNumber) {
              this.vendorInformation.name = this.clientLists[0].name ?? "";
              this.getAllContactsByAccountNumber(
                this.customerIdD365,
                this.clientLists[0]?.partyNumber
              );
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  setPdfFileName() {
    if (this.windowState == EnumOrderEmailState.ProjectConfirmation) {
      this.fileName = `ProjectConfirmation-${this.saleOrderId}.pdf`;
    } else if (this.windowState == EnumOrderEmailState.PrintOrderSummary) {
      this.fileName = `OrderSummary-${this.saleOrderId}.pdf`;
    } else if (this.windowState == EnumOrderEmailState.PrintProjectApproval) {
      this.fileName = `ProjectApproval-${this.saleOrderId}.pdf`;
    } else {
      this.fileName = this.poNumber
        ? `${this.poNumber}.pdf`
        : `${this.poNumberParams}.pdf`;
    }
  }

  refreshOrderLinesGridEvent() {
    this.refreshOrderLinesGrid.emit();
  }

  getFileSizeFromBase64(base64String: string): number {
    const cleanedBase64 = base64String.split(",").pop() ?? "";
    const paddingMatch = /=+$/.exec(cleanedBase64);
    const padding = paddingMatch ? paddingMatch[0].length : 0;
    return (cleanedBase64.length * 3) / 4 - padding;
  }

  closePOEmailModal() {
    this.closePOEmailModalEvent.emit();
  }
}
